import { useSyncExternalStore } from 'react';

const QUERY = '(min-width: 900px)';

function subscribe(onChange: () => void): () => void {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener('change', onChange);
  // Belt-and-braces: some environments (embedded webviews, CDP-driven
  // viewport emulation used in automated browser testing) don't reliably
  // fire a MediaQueryList 'change' event on every resize path, even though
  // `matchMedia(...).matches` itself is already up to date. A plain window
  // resize listener costs nothing and closes that gap.
  window.addEventListener('resize', onChange);
  return () => {
    mq.removeEventListener('change', onChange);
    window.removeEventListener('resize', onChange);
  };
}

function getSnapshot(): boolean {
  return window.matchMedia(QUERY).matches;
}

/** The same `(min-width: 900px)` breakpoint the mobile tab bar / desktop
 *  sidebar split hinges on across the app. `src/ui/components/AppBar.tsx`
 *  also hardcodes this value as a Tailwind `min-[900px]:` arbitrary variant
 *  (no JS-constant way to share it with a class name) — keep both in sync
 *  by hand if this ever changes. */
export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
